<div class="container h-full">
  @if ((defaultStoreSubscription$ | async)?.attributes.status === 'declined') {
    <ng-container [ngTemplateOutlet]="declinedShopifySubscription"></ng-container>
  }

  @if ((defaultStoreSubscription$ | async)?.attributes.status === 'expired') {
    <ng-container [ngTemplateOutlet]="expiredShopifySubscription"></ng-container>
  }

  <div class="flex flex-col gap-6" *transloco="let t">
    <div class="flex flex-col">
      <h1 class="text-2xl font-semibold mb-2">{{ t('dashboard.heading') }}</h1>
    </div>

    @if ((hasFailedBookkeepingJob$ | async) === true) {
      <ng-container [ngTemplateOutlet]="failedBookkeepingJob"></ng-container>
    }

    <div class="grid gap-6 grid-cols-1 lg:grid-cols-2" *transloco="let t">
      <p-card styleClass="min-h-[160px] relative h-full">
        <div class="absolute top-0 right-0 m-2 z-10">
          <p-button text rounded [loading]="loading$ | async" (onClick)="onLoadStatistics()">
            <ng-template #icon>
              <fa-icon [icon]="['fal', 'sync-alt']" [fixedWidth]="true" />
            </ng-template>
            <ng-template #loadingicon>
              <fa-icon [icon]="['fal', 'sync-alt']" [fixedWidth]="true" animation="spin" />
            </ng-template>
          </p-button>
        </div>
        <div class="flex flex-col h-full justify-center">
          <div class="flex items-center gap-5 py-4">
            <div class="p-4 rounded-lg flex items-center justify-center">
              <fa-duotone-icon
                primaryColor="#1E40AF"
                secondaryColor="#60A5FA"
                [icon]="['fad', 'list-check']"
                size="4x"
                [fixedWidth]="true"
              ></fa-duotone-icon>
            </div>
            <div class="text-center grow">
              <h2 class="text-4xl font-semibold mb-1">
                {{ bookkeepingJobsCount$ | async }}
              </h2>
              <p class="text-p-muted-color text-sm m-0">
                {{ t('dashboard.cards.bookkeeping-jobs') }}
              </p>
            </div>
          </div>
        </div>
      </p-card>

      <p-card styleClass="min-h-[160px] relative h-full">
        <div class="absolute top-0 right-0 m-2 z-10">
          <p-button text rounded [loading]="loading$ | async" (onClick)="onLoadStatistics()">
            <ng-template #icon>
              <fa-icon [icon]="['fal', 'sync-alt']" [fixedWidth]="true" />
            </ng-template>
            <ng-template #loadingicon>
              <fa-icon [icon]="['fal', 'sync-alt']" [fixedWidth]="true" animation="spin" />
            </ng-template>
          </p-button>
        </div>
        <div class="flex flex-col h-full justify-center">
          <div class="flex items-center gap-5 py-4">
            <div class="p-4 rounded-lg flex items-center justify-center">
              <fa-duotone-icon
                primaryColor="#059669"
                secondaryColor="#34D399"
                [icon]="['fad', 'cart-shopping']"
                size="4x"
                [fixedWidth]="true"
              ></fa-duotone-icon>
            </div>
            <div class="text-center grow">
              <h2 class="text-4xl font-semibold mb-1">
                {{ ordersCount$ | async }}
              </h2>
              <p class="text-p-muted-color text-sm m-0">
                {{ t('dashboard.cards.orders-today') }}
              </p>
            </div>
          </div>
        </div>
      </p-card>

      <p-card styleClass="min-h-[160px] relative h-full">
        <div class="absolute top-0 right-0 m-2 z-10">
          <p-button text rounded [routerLink]="['/stores/sales-platform']">
            <ng-template #icon>
              <fa-icon [icon]="['fal', 'circle-plus']" [fixedWidth]="true" />
            </ng-template>
          </p-button>
        </div>
        <div class="flex flex-col h-full justify-center">
          <div class="flex items-center gap-5 py-4">
            <div class="p-4 rounded-lg flex items-center justify-center">
              <fa-duotone-icon
                primaryColor="#7C3AED"
                secondaryColor="#A78BFA"
                [icon]="['fad', 'store']"
                size="4x"
                [fixedWidth]="true"
              ></fa-duotone-icon>
            </div>
            <div class="text-center grow">
              <h2 class="text-4xl font-semibold mb-1">
                {{ activeStoresCount$ | async }}
              </h2>
              <p class="text-p-muted-color text-sm m-0">
                {{ t('dashboard.cards.stores') }}
              </p>
            </div>
          </div>
        </div>
      </p-card>

      <p-card styleClass="min-h-[160px] relative h-full">
        <div class="flex flex-col h-full justify-center">
          <div class="flex items-center gap-5 py-4">
            <div class="p-4 rounded-lg flex items-center justify-center">
              <fa-duotone-icon
                primaryColor="#DC2626"
                secondaryColor="#F87171"
                [icon]="['fad', 'chart-network']"
                size="4x"
                [fixedWidth]="true"
              ></fa-duotone-icon>
            </div>
            <div class="text-center grow">
              <h2 class="text-4xl font-semibold mb-1">
                {{ integrationsCount$ | async }}
              </h2>
              <p class="text-p-muted-color text-sm m-0">
                {{ t('dashboard.cards.integrations') }}
              </p>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div class="text-right text-p-muted-color italic text-sm">
      {{ t('dashboard.lastUpdated') }}
      @if (lastUpdatedAt$ !== undefined) {
        {{ lastUpdatedAt$ | async }}
      }
    </div>
  </div>
</div>

<ng-template #declinedShopifySubscription>
  <p-message styleClass="mb-4 w-full py-4 px-5 dark:border-gray-200/30" severity="info" [closable]="false">
    <div class="flex flex-col md:flex-row items-start md:items-center gap-4" *transloco="let t">
      <span class="grow">
        {{ t('dashboard.messages.declinedShopifySubscription') }}
      </span>
      <div class="flex gap-2">
        @if ((defaultStore$ | async)?.id; as storeId) {
          <button
            pButton
            [label]="t('dashboard.buttons.reactivate')"
            [loading]="savingSubscription$ | async"
            (click)="onReactivateSubscription(+storeId)"
            class="p-button-sm"
          ></button>
          <button
            pButton
            [label]="t('dashboard.buttons.goToSubscription')"
            class="p-button-sm p-button-outlined"
            [routerLink]="['/integrations', storeId, 'subscriptions']"
          >
            <span class="mr-2">{{ t('dashboard.buttons.goToSubscription') }}</span>
            <fa-icon [icon]="['fal', 'arrow-right']" />
          </button>
        }
      </div>
    </div>
  </p-message>
</ng-template>

<ng-template #expiredShopifySubscription>
  <p-message styleClass="mb-4 w-full py-4 px-5 dark:border-gray-200/30" severity="info" [closable]="false">
    <div class="flex flex-col md:flex-row items-start md:items-center gap-4" *transloco="let t">
      <span class="grow">
        {{ t('dashboard.messages.expiredShopifySubscription') }}
      </span>
      <div class="flex gap-2">
        @if ((defaultStore$ | async)?.id; as storeId) {
          <button
            pButton
            [label]="t('dashboard.buttons.reactivate')"
            [loading]="savingSubscription$ | async"
            (click)="onReactivateSubscription(+storeId)"
            class="p-button-sm"
          ></button>
          <button
            pButton
            class="p-button-sm p-button-outlined"
            [routerLink]="['/integrations', storeId, 'subscriptions']"
          >
            <span class="mr-2">{{ t('dashboard.buttons.goToSubscription') }}</span>
            <fa-icon [icon]="['fal', 'arrow-right']" />
          </button>
        }
      </div>
    </div>
  </p-message>
</ng-template>

<ng-template #failedBookkeepingJob>
  <p-message styleClass="mb-4 w-full py-4 px-5 dark:border-gray-200/30" severity="warn">
    <span *transloco="let t">
      {{ t('dashboard.messages.failedBookkeepingJobs') }}
    </span>
  </p-message>
</ng-template>
